const { CONSTANTS } = require('../../../../config')

/**
 * @param {*} value
 * @returns {string|undefined}
 */
function accountNo (value) {
  if (!value) return

  const values = value
    .toString()
    .split(':')

  const accountNo = values?.[0]?.replace(/[^0-9]+/g, '')
  const bankId = parseInt(values?.[1])

  if (!accountNo) return
  if (!bankId) return accountNo

  const accountNoFirstDigit = parseInt(accountNo.substr(0, 1))
  const clearingNoLength = (
    CONSTANTS.SE.FIVE_DIGIT_CLEARING_NO.includes(bankId) ||
    (bankId === CONSTANTS.SE.BANKS.SWEDBANK && accountNoFirstDigit === 8)
  )
    ? 5
    : 4

  if (accountNo.length <= clearingNoLength) return accountNo

  const clearingNumber = accountNo
    .substr(0, clearingNoLength)
  const accountNumber = accountNo
    .substr(clearingNoLength)

  return `${clearingNumber} ${accountNumber}`
}

module.exports = { accountNo }
